import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import HorizontalBarChart from "../../../ceo/analysis/competitive/charts/horizontal-bar";

class TeamReportsSection2Step8 extends PureComponent {
  get Revenues() {
    const { teams, competition_metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          competition_metrics[team_id] &&
          competition_metrics[team_id]["Revenues"]
            ? competition_metrics[team_id]["Revenues"] / 1000000
            : 0
      });
    });

    return data;
  }

  get left_content() {
    return (
      <span>
        Revenues are the total dollar sales that a business might generate
        within a period of time. It is calculated by taking the number of units
        sold multiplied by the selling price of each unit:
        <br />
        <br />
        <div className="formula">
          REVENUES = UNIT SALES X UNIT SELLING PRICE
        </div>
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <HorizontalBarChart
          prefix="$"
          suffix="M"
          precision={3}
          data={this.Revenues}
        />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Revenues
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Revenues"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step8;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-8.js